import { Box, Stack } from "@compass/core";
import { Outlet } from "react-router";
import { ReactNode, createContext, useState } from "react";
// importing NavigationBar and AppTopBar directly from components causes problem with fast refresh?
import { NavigationBar } from "components/common/NavigationBar/NavigationBar";
import { AppTopBar } from "components/common/AppTopBar/AppTopBar";

export const NavLayoutContext = createContext<{
  subBar?: ReactNode;
  setSubBar?: (value: ReactNode) => void;
}>({});

export const NavLayout = () => {
  const [navSubBar, setNavSubBar] = useState<ReactNode>();

  return (
    <NavLayoutContext.Provider value={{ subBar: navSubBar, setSubBar: setNavSubBar }}>
      <Stack direction="row" minHeight="100vh" className="nav-layout">
        <NavigationBar subBar={navSubBar} />

        <Stack position="relative" width="100%" className="layout-main">
          <AppTopBar />

          <Box position="relative" flexGrow={1} flexShrink={0} className="page-container">
            <Outlet />
          </Box>
        </Stack>
      </Stack>
    </NavLayoutContext.Provider>
  );
};
